import PromoBox from './PromoBox';
import cn from 'classnames';
import Container from '@components/global/Container';
import Heading from '@components/ui/Heading';
import {
  PageType,
  PrimaryPromoBoxesSliceData,
} from '@adapters/prismic/types/slices';

import styles from './PrimaryPromoBoxes.module.scss';

const PrimaryPromoBoxes = ({
  title,
  centerTitle,
  items,
  trackPromos,
  pageType,
  sliceIndex,
}: {
  title: PrimaryPromoBoxesSliceData['primary']['title'];
  centerTitle: PrimaryPromoBoxesSliceData['primary']['center_align'];
  items: PrimaryPromoBoxesSliceData['items'];
  trackPromos?: boolean;
  pageType: PageType;
  sliceIndex: number;
}) => {
  if (!items || items.length === 0) {
    return null;
  }
  return (
    <Container>
      <div className={styles.sectionContainer}>
        {title && (
          <div
            className={cn(styles.titleContainer, {
              [styles.centerTitle]: centerTitle,
            })}
          >
            <Heading semanticLevel="h2" styleLevel="1">
              {title}
            </Heading>
          </div>
        )}
        <div className={styles.container}>
          {items.map((item, index) => (
            <PromoBox
              key={`primary-promo-box-${item?.url}`}
              item={item}
              trackPromos={trackPromos}
              pageType={pageType}
              sliceIndex={sliceIndex}
              positionWithinSlice={index}
            />
          ))}
        </div>
      </div>
    </Container>
  );
};

export default PrimaryPromoBoxes;
